import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { QuoteDetail } from '../models/quote';
import { IncidentClientLink } from '../models/client';

@Injectable({
  providedIn: 'root'
})
export class QuoteService {
 
  apiUrl = 'v1/quote/';

  constructor(private http: HttpClient) { }

  public generateQuoteEstimate(incidentId: number, clientId: number) {
    return this.http.post<{"detail": string}>(`${environment.apiUrl}${this.apiUrl}generate/${incidentId}/${clientId}`, null);
  }

  public getQuote(quoteId: number) {
    return this.http.get<QuoteDetail>(`${environment.apiUrl}${this.apiUrl}${quoteId}`);
  }

  public updateQuote(quote: QuoteDetail) {
    return this.http.put<QuoteDetail>(`${environment.apiUrl}${this.apiUrl}${quote.quoteId}`, quote);
  }

  public generateQuoteToFleet(quoteId: number, incidentId: number, clientId: number, sellerId: number) { 
    return this.http.post<QuoteDetail>(`${environment.apiUrl}${this.apiUrl}generate/${incidentId}/seller/${sellerId}/client/${clientId}/quote/${quoteId}`, null);
  }

  public previewQuotePricing(quoteId: number, pricingTemplateId: number) {
    return this.http.get<QuoteDetail>(`${environment.apiUrl}${this.apiUrl}quote/${quoteId}/pricing/${pricingTemplateId}`);
  }

  public runServiceProviderChecks(incidentId: number, clientId: number, clientLink: IncidentClientLink) {
    return this.http.post<IncidentClientLink>(`${environment.apiUrl}${this.apiUrl}incident/${incidentId}/serviceProvider/${clientId}`, clientLink);
  }

  public runServiceProviderQuote(incidentId: number, clientId: number, clientLink: IncidentClientLink) {
    return this.http.post<IncidentClientLink>(`${environment.apiUrl}${this.apiUrl}incident/${incidentId}/serviceProvider/${clientId}/quote`, clientLink);
  }

  public convertQuoteToInvoice(quoteId: number) {
    return this.http.post<{detail: string}>(`${environment.apiUrl}${this.apiUrl}sale/${quoteId}`, null);
  }

  public convertQuoteToJobcard(quoteId: number) {
    return this.http.post<{detail: string}>(`${environment.apiUrl}${this.apiUrl}jobcard/${quoteId}`, null);
  }

}
